import { JSX } from "react";
import { useTranslation } from "react-i18next";

import MovieCard from "@/components/cards/MovieCard";
import Carousel from "@/components/helpers/Carousel.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { ContentHistory } from "@/api/feed/feed.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { useGetContentHistory } from "@/hooks/api/feed.hooks.ts";
import { isMobile } from "@/utils/constatns";

const MainHistorySection = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: history } = useGetContentHistory(18);

  if (!history.pages[0].results.length) return <></>;

  return (
    <Section title={t("recently-watched")} link={ROUTES.HISTORY} className={`group/section`}>
      <Carousel<ContentHistory>
        swiperParams={{
          slidesPerView: 2,
          spaceBetween: 16,
          followFinger: isMobile,
          breakpoints: {
            576: { slidesPerView: 3, slidesPerGroup: 3 },
            992: { slidesPerView: 4, slidesPerGroup: 4 },
            1200: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
            1400: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
          },
        }}
        items={history.pages[0].results}
        swiperName={"history"}
        className={"pb-0.5"}
      >
        {(content) => (
          <MovieCard
            key={content.content.id}
            {...content.content}
            time_code={content.time_code}
            duration={content.duration}
          />
        )}
      </Carousel>
    </Section>
  );
};

export default MainHistorySection;
